import { render, staticRenderFns } from "./IconSvgAv.vue?vue&type=template&id=79491768&scoped=true&"
import script from "./IconSvgAv.vue?vue&type=script&lang=js&"
export * from "./IconSvgAv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79491768",
  null
  
)

export default component.exports